<template>
  <div>
    <oxd-dialog
      v-if="showModal"
      :style="{width: '90%', maxWidth: '450px'}"
      @update:show="showModal = false"
    >
      <div class="orangehrm-modal-header">
        <oxd-text type="card-title">
          {{ data.id ? 'Edit Company Document' : 'Add Company Document' }}
        </oxd-text>
      </div>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="1" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="data.name"
                :label="$t('general.name')"
                :rules="rules.name"
                required
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-form-row>
          <oxd-grid :cols="1" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="data.value"
                :label="$t('general.url')"
                :rules="rules.value"
                required
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </oxd-dialog>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import {
  required,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';

const validUrl = (value) => {
  if (!value?.trim()) {
    return true;
  }
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:'
      ? true
      : 'Invalid URL';
  } catch {
    return 'Invalid URL';
  }
};

const initialData = {
  id: null,
  name: '',
  value: '',
};

export default {
  emits: ['close'],

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/companies',
    );

    return {
      http,
    };
  },

  data() {
    return {
      showModal: false,
      isLoading: false,
      data: {...initialData},
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
        value: [required, validUrl],
      },
    };
  },

  methods: {
    openModal(company = null) {
      this.showModal = true;
      this.isLoading = false;

      if (company) {
        this.data = {
          id: company.id,
          name: company.name,
          value: company.value,
        };
      } else {
        this.data = {...initialData};
      }
    },

    onCancel() {
      this.showModal = false;
      this.data = {...initialData};
    },

    async onSave() {
      this.isLoading = true;
      try {
        const payload = {
          name: this.data.name.trim(),
          value: this.data.value.trim(),
        };

        let response;
        if (this.data.id) {
          // Update existing company
          response = await this.http.update(this.data.id, payload);
        } else {
          // Create new company
          response = await this.http.create(payload);
        }

        if (response.status === 200) {
          this.$toast.saveSuccess();
          this.onCancel();
          this.$emit('close');
        }
      } catch (error) {
        this.$toast.error({
          title: this.$t('general.toast_messages.generic_error_title'),
          message: this.$t('general.toast_messages.generic_error_message'),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
